import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore, selectIsSessionValid } from '../store/userStore';
import { appLoginPath } from '../routes/appPaths';

/** Гость → показать промпт входа; авторизованный → выполнить action. */
export function useAuthGate() {
  const navigate = useNavigate();
  const userId = useUserStore((s) => s.userId);
  const isAuthed = useUserStore(selectIsSessionValid);

  const [loginNext, setLoginNext] = useState<string | null>(null);

  const requireAuth = useCallback(
    (nextPath: string, action: () => void) => {
      if (isAuthed) {
        action();
        return;
      }
      setLoginNext(nextPath);
    },
    [isAuthed],
  );

  const closeAuthPrompt = useCallback(() => setLoginNext(null), []);

  const confirmAuthPrompt = useCallback(() => {
    if (!loginNext) return;
    navigate(appLoginPath(loginNext));
    setLoginNext(null);
  }, [loginNext, navigate]);

  return {
    isAuthed,
    userId,
    authPromptOpen: !!loginNext,
    requireAuth,
    closeAuthPrompt,
    confirmAuthPrompt,
  };
}
